// src/pages/reportUsage/utils/validatingSerialAndQty.js

import { convertDataRpToRecord } from "./dataModificaionUtil";

/**
 * Utility to validate serial and quantity for report payment.
 * @param {Object} params - All required references and values.
 * @param {string} params.myCaseResourceType
 * @param {boolean} params.showReportPayment
 * @param {Array} params.itemTableData
 * @param {string|number} params.myCaseRefId
 * @param {Object} params.usageDetails
 * @param {Function} params.getValidateItemsArr
 * @param {Function} params.setReportPaymentFlag
 * @param {Function} params.dispatch
 * @param {Function} params.validateProductDetails
 */
export const validatingSerialAndQtyUtil = ({
  myCaseResourceType,
  showReportPayment,
  itemTableData,
  myCaseRefId,
  usageDetails,
  getValidateItemsArr,
  setReportPaymentFlag,
  dispatch,
  validateProductDetails
}) => {
  if (
    myCaseResourceType === 'reportUsage' &&
    !showReportPayment &&
    itemTableData.length > 0 &&
    myCaseRefId &&
    !usageDetails.unidId
  ) {
    const validateItemsArr = getValidateItemsArr(convertDataRpToRecord(itemTableData));
    validateItemsArr.map(
      (item) => item.AccountOwned == undefined && delete item.AccountOwned
    );
    const validateItemsObj = {
      myCaseRef: myCaseRefId,
      products: validateItemsArr,
    };
    setReportPaymentFlag(true);
    dispatch(validateProductDetails(validateItemsObj, true));
  }
};
